module.exports = __webpack_public_path__ + "img/svg/step9.6cd6e780f8798ea118713740c8252473.svg";